import { createSlice } from "@reduxjs/toolkit";
export const searchDataSlice = createSlice({
    name: 'searchDataSlice',
    initialState: {
        city: {
            name: "",
            value: ""
        },
        activityFacility: {
            name: "",
            value: ""
        },
        cards: [],
        sort: 'az',
        sortClicked: null,
        coordinates: {
            lat: null,
            lng: null
        },
        filters: {
            activityGroup: {},
            discountCategory: {},
            amenity: {}
        },
        location: {},
        locationChecked: false,
        locationModalToggle: false,

    },
    reducers: {
        setCardsData: (state, action) => {
            if (action.payload.type === 'add') {
                let filter = state.cards.some(card => card == action.payload.card);
                if (!filter) {
                    state.cards = state.cards.concat(action.payload.card);
                }
            } else if (action.payload.type === 'remove') {
                state.cards = state.cards.filter(item => item != action.payload.card)
            }
        },
        clearFilterType: (state, action) => {
            state.filters = Object.assign({}, {
                ...state.filters,
                [action.payload]: {}
            })
        },
        setFilter: (state, action) => {
            state.filters = Object.assign({}, {
                ...state.filters,
                [action.payload.type]: {
                    ...state.filters[action.payload.type],
                    [action.payload.id]: {
                        name: action.payload.name
                    }
                }
            })
        },
        removeFilter: (state, action) => {
            delete state.filters[action.payload.type][action.payload.id]
        },
        clearFilter: (state, action) => {
            state.filters = Object.assign({}, {
                activityGroup: {},
                discountCategory: {},
                amenity: {}
            })
        },
        setFilterObject: (state, action) => {
            state.filters = Object.assign({}, {
                ...state.filters,
                [action.payload.type]: Object.assign({}, action.payload.obj)
            })
        },
        setCityData: (state, action) => {
            state.city = action.payload
            if(action.payload.name !== "" && action.payload.value !== ""){
                state.locationChecked = false
                state.location = {}
            }
        },
        setActivityFacilityData: (state, action) => {
            state.activityFacility = action.payload
        },
        setSort: (state, action) => {
            state.sort = action.payload.value;
            if (action.payload.action) {
                state.sortClicked = action.payload.action && action.payload.action
            }
        },
        setLocation: (state, action) => {
            state.locationChecked = action.payload.checked
            state.location = action.payload.location
            state.city = {
                name: "",
                value: ""
            }
        },
        toggleLocationModal: (state, action) => { 
            state.locationModalToggle= action.payload
        }
    }
}
)


